export enum PricingPath {
  List = "list",
  Special = "special",
}
